import { UPDATE_BOTSPEC_PARSER_ERRORS } from '../namespace';

export const updateBotspecParsingErrors = (errors) => ({
  type: UPDATE_BOTSPEC_PARSER_ERRORS,
  payload: { errors },
});

const validateEntryPoint = (entrypoint) => (!entrypoint ? 'There is no entrypoint defined' : '');

export const validateSpec = (reteJson) => {
  const { entryPoint } = reteJson;
  const messages = [
    validateEntryPoint(entryPoint),
  ].filter((message) => message !== '');

  return messages;
};
